/* eslint-disable no-undef */

import store from "./store/stores";

// Import application bootstrapping
import "./bootstrap";

// Import theme and custom written Javascript
import "./custom";
import "./checkout";
import "./changePayment";
import "./manageCreditCards";

// Must be the last import unless testing proves otherwise.
import "./child";

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
const files = require.context("./", true, /\.vue$/i);
files
  .keys()
  .map((key) =>
    Vue.component(key.split("/").pop().split(".")[0], files(key).default)
  );

/**
 * For dusk testing, we may want to create a dusk="something-here" selector.
 * To do this, add the v-dusk attribute like this: v-dusk="'something-here'".
 * Will not output anything in production-based compiles
 */
Vue.directive("dusk", (el, binding) => {
  if (process.env.NODE_ENV !== "production") {
    el.setAttribute("dusk", binding.value);
  }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
// eslint-disable-next-line no-unused-vars
const app = new Vue({
  el: "#app",
  store,
});
